<template>
  <div class="row">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="col-4 mb-3 text-white text-center">
      <h3 v-html="item.name" class="h3 mb-0"></h3>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SkillsetListComponent',
  props: {
    list: Array
  }
}
</script>